import { gql } from "@apollo/client";

export const GET_DOCUMENT_TYPES = gql`
  query GetDocumentTypes {
    getDocumentTypes {
      message
      data {
        id
        name
        isActive
      }
    }
  }
`;
